module.exports = __webpack_public_path__ + "static/media/confirm.14be0c5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/confirm.svg
// module id = 43
// module chunks = 0